module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEGSURBVHgBrVLLDYJAEJ1dvHnRDvRkuGkHlkBoQFuwArQC7UBtgGAHdoA3YjxoB3JS4mHH2V1+IgENvISwOzPvzW8BGoKVWq1gAMzYAsMx3Xr0eSDEAjzzVi8gyZz7MTGPkEQmRRH+JWDwtSKj2IN49Ik0BIS9ssmqaiuwz6j+kphks6494K+7qsId9asrkEEKUZiZoqSdYlslAshO2tNdq3lYPmU3HO3DA9S20HiIMkAGytUlRGTHMnIr+GzBCqa0Kif3gDK4I5ZuKGfrpBf7QoMSS5oU/INOnHmuyRJiBSLagDcJfxdgxkxnxgW45qaaQgkUuJMTwKn2PXe1ZNdcqqMdQCt4A4bHZBesDwwRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imag3.png
// module id = YECI
// module chunks = 0